import React, { Component } from 'react';
import HeaderRespira from '../../assets/images/respira/__header.png';
import IllustrationRespira from '../../assets/images/respira/__illustration.png';
import ProjectHeader from '../ProjectHeader';

class ProjectRespira extends Component {
	render() {
		return (
			<div className="publish-container__wrapper">
				<ProjectHeader />
				<h1 className="title-h1 bold">Respira</h1>
				<span className="title-caption step-4">Breathing exercise for anxiety</span>
				<div className="publish-container">
					<img src={HeaderRespira} alt="Caption for single" />
					<p>
						A simple project, meant to guide the user with the 4-4-4 breathing exercise. Used reactjs
						framework and {' '}
						<a href="https://airbnb.io/lottie/" target="_blank" className="link">
							lottie-web
						</a>{' '}
						for animations. {' '}<br></br>
						Based on artwork by {' '}
						<a href="https://dribbble.com/shots/3215137-Fri-yay" target="_blank" className="link">
							Meg
						</a>.{' '}
					</p>
					<p>
						You can check the page{' '}
						<a href="https://respira.room.pt" target="_blank" className="link">
							here
						</a>.
					</p>
					<a class="link--image hoverable" target="_blank" href="https://respira.room.pt">
						<img to="/" src={IllustrationRespira} alt="Respira illustration" />
					</a>
					<br />
					<p>Thank you.</p>
				</div>
			</div>
		);
	}
}

export default ProjectRespira;
